/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ListSentencesParams = zod.object({
	actor_id: zod.string(),
	status: zod.enum(['proposed', 'accepted', 'rejected', 'completed']).optional()
});

export type ListSentencesParams = zod.input<typeof ListSentencesParams>;
export type ListSentencesParamsOutput = zod.output<typeof ListSentencesParams>;
